import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { WarehouseService } from "../warehouse.service";
import { Location } from "@angular/common";

@Component({
  selector: "app-view-warehouse",
  templateUrl: "./view-warehouse.component.html",
  styleUrls: ["./view-warehouse.component.sass"],
})
export class ViewWarehouseComponent implements OnInit {
  requirementId: string = "";
  warehouseDetails: any = {};

  constructor(
    private route: ActivatedRoute,
    private warehouseService: WarehouseService,
    private location: Location,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.requirementId = params["id"];

      if (this.requirementId) {
        this.getWarehouseRequirement();
      }
    });
  }

  getWarehouseRequirement(): void {
    const payload = {
      id: this.requirementId,
    };

    this.warehouseService.getWarehouseRequirementById(payload).subscribe({
      next: (res: any) => {
        this.warehouseDetails = res.data;
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  goBack(): void {
    this.location.back();
  }
}
